import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Pricing() {
  return (
    <section id="pricing" className="py-20 md:py-28" data-testid="pricing-section">
      <div className="max-w-5xl mx-auto px-5 sm:px-8">
        <div className="relative rounded-3xl bg-brand-primary text-white p-10 md:p-14 overflow-hidden shadow-xl">
          <div
            aria-hidden
            className="absolute -right-16 -top-16 w-72 h-72 rounded-full bg-white/10 blur-2xl"
          />
          <div
            aria-hidden
            className="absolute -left-16 -bottom-16 w-72 h-72 rounded-full bg-white/10 blur-2xl"
          />
          <div className="relative grid lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-8">
              <span className="uppercase text-xs tracking-[0.22em] font-bold text-white/80">
                Simple, Tailored Pricing
              </span>
              <h2 className="mt-3 font-heading font-medium text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white">
                Pricing that fits your startup size and stage.
              </h2>
              <p className="mt-4 text-white/85 leading-relaxed max-w-xl">
                Every company is different, so we keep pricing flexible and conversation-led.
                Share a bit about your need and we’ll send a clear, no-surprise proposal.
              </p>
            </div>
            <div className="lg:col-span-4 flex lg:justify-end">
              <Button
                asChild
                className="rounded-full bg-white text-brand-primary hover:bg-white/90 h-12 px-6 text-sm font-semibold"
                data-testid="pricing-cta"
              >
                <a href="#contact" className="inline-flex items-center gap-2">
                  Contact for Pricing <ArrowRight size={16} />
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
